import React, { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, formatCurrency } from "../../lib/api";
import { QuickList, inputCls } from "./QuickList";

export default function RolesStep({ roles, setRoles }) {
  const [f, setF] = useState({ name: "", function: "", rate: "" });

  const add = async (e) => {
    e.preventDefault();
    if (!f.name.trim()) return;
    try {
      const { data } = await api.post("/roles", { data: { name: f.name.trim(), function: f.function, rate: Number(f.rate || 0), other_details: "", custom_fields: {} } });
      setRoles((x) => [data, ...x]);
      setF({ name: "", function: "", rate: "" });
    } catch (e2) { toast.error(errMsg(e2)); }
  };
  const remove = async (r) => {
    try { await api.delete(`/roles/${r.id}`); setRoles((x) => x.filter((y) => y.id !== r.id)); } catch (e) { toast.error(errMsg(e)); }
  };

  return (
    <div data-testid="wizard-step-roles">
      <p className="text-sm text-slate-400 mb-3">Roles define the hourly rate that drives every cost estimate. Add the roles this project needs.</p>
      <QuickList items={roles} onDelete={remove} testId="wizard-roles-list" empty="No roles yet. Add your first one below."
        render={(r) => <><span className="font-medium">{r.name}</span><span className="text-slate-500"> · {formatCurrency(r.rate || 0)}/hr{r.function ? ` · ${r.function}` : ""}</span></>} />
      <form onSubmit={add} className="grid grid-cols-1 sm:grid-cols-[1fr_1fr_110px_auto] gap-2">
        <input className={inputCls} placeholder="Role name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="wizard-role-name" />
        <input className={inputCls} placeholder="Function (optional)" value={f.function} onChange={(e) => setF({ ...f, function: e.target.value })} data-testid="wizard-role-function" />
        <input className={inputCls} type="number" min={0} placeholder="Rate/hr" value={f.rate} onChange={(e) => setF({ ...f, rate: e.target.value })} data-testid="wizard-role-rate" />
        <button type="submit" data-testid="wizard-role-add" className="inline-flex items-center justify-center gap-1 bg-blue-600 hover:bg-blue-500 text-white px-3 py-2 rounded-lg text-sm"><Plus size={14} /> Add</button>
      </form>
    </div>
  );
}
